import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PendingEhsApprovalFormsListComponent } from '../../components/pending-ehs-approval-forms-list/pending-ehs-approval-forms-list.component';

@Component({
  selector: 'app-ehs-review-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    PendingEhsApprovalFormsListComponent
  ],
  templateUrl: './ehs-review-page.component.html',
  styleUrl: './ehs-review-page.component.scss'
})
export class EhsReviewPageComponent {

}
